import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';

// Helper component for table cells
const Cell = ({ label, value, widthLabel, widthValue }) => (
    <>
        <View style={[styles.tableCol, { width: widthLabel + '%' }]}>
            <Text style={styles.tableCellLabel}>{label}</Text>
        </View>
        <View style={[styles.tableCol, { width: widthValue + '%' }]}>
            <Text style={styles.tableCellValue}>{value || ''}</Text>
        </View>
    </>
);

export const TablesComponent = ({ data, type = 'PM' }) => {
    const t = data.tenant;
    const lr = data.legalRep || {};
    const g = data.guarantor || {};

    // Format dates if needed
    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('es-MX');
        } catch (e) {
            return dateString;
        }
    };

    return (
        <>
            {/* Table Title: Datos del arrendatario */}
            <Text style={[styles.tableTitle, type === 'PM' && { marginTop: 5 }]}>Datos del arrendatario</Text>
            <View style={styles.table}>
                {type === 'PM' ? (
                    <>
                        {/* Row 1 */}
                        <View style={styles.tableRow}>
                            <Cell label="Nombre del arrendamiento" value={t.nombreArrendamiento} widthLabel={20} widthValue={40} />
                            <Cell label="No. Contrato" value={t.numeroContrato} widthLabel={15} widthValue={25} />
                        </View>
                        {/* Row 2 */}
                        <View style={styles.tableRow}>
                            <Cell label="Domicilio Operativo" value={t.domicilioOperativo} widthLabel={20} widthValue={80} />
                        </View>
                        {/* Row 3 */}
                        <View style={styles.tableRow}>
                            <Cell label="Domicilio Fiscal" value={t.domicilioFiscal} widthLabel={20} widthValue={80} />
                        </View>
                        {/* Row 4 */}
                        <View style={styles.tableRow}>
                            <Cell label="RFC" value={t.rfc} widthLabel={10} widthValue={23} />
                            <Cell label="Núm. Teléfono" value={t.telefono} widthLabel={15} widthValue={18} />
                            <Cell label="Correo" value={t.correo} widthLabel={10} widthValue={24} />
                        </View>
                        {/* Row 5 */}
                        <View style={styles.tableRow}>
                            <Cell label="F Registro" value={formatDate(t.fechaRegistro)} widthLabel={15} widthValue={18} />
                            <Cell label="Act. económica" value={t.actividadEconomica} widthLabel={15} widthValue={18} />
                            <Cell label="Fecha Inscripción" value={formatDate(t.fechaInscripcion)} widthLabel={15} widthValue={19} />
                        </View>
                        {/* Row 6 */}
                        <View style={styles.tableRow}>
                            <Cell label="F Constitución" value={formatDate(t.fechaConstitucion)} widthLabel={15} widthValue={18} />
                            <Cell label="N. Escritura" value={t.numeroEscritura} widthLabel={15} widthValue={18} />
                            <Cell label="Libro" value={t.libro} widthLabel={10} widthValue={24} />
                        </View>
                        {/* Row 7 */}
                        <View style={styles.tableRow}>
                            <Cell label="Fedatario No." value={t.fedatarioNumero} widthLabel={15} widthValue={18} />
                            <Cell label="Entidad Fed." value={t.entidadFederativa} widthLabel={15} widthValue={18} />
                            <Cell label="Nombre" value={t.fedatarioNombre} widthLabel={10} widthValue={24} />
                        </View>
                        {/* Row 8 */}
                        <View style={styles.tableRow}>
                            <Cell label="Opinión Cumplí." value={t.opinionCumplimiento} widthLabel={15} widthValue={18} />
                            <Cell label="Estatus" value={t.estatus} widthLabel={10} widthValue={23} />
                            <Cell label="IdCIF" value={t.idCIF} widthLabel={10} widthValue={24} />
                        </View>
                        {/* Row 9 */}
                        <View style={styles.tableRow}>
                            <Cell label="Régimen Fiscal" value={t.regimenFiscal} widthLabel={20} widthValue={80} />
                        </View>
                    </>
                ) : (
                    <>
                        {/* PF Rows */}
                        {/* Fila 1: Nombre del arrendamiento (2 cols label) | No. Contrato (2 cols label) */}
                        <View style={styles.tableRow}>
                            <Cell label="Nombre del arrendamiento" value={t.nombreArrendatario} widthLabel={20} widthValue={40} />
                            <Cell label="No. Contrato" value={t.numeroContrato} widthLabel={15} widthValue={25} />
                        </View>

                        {/* Fila 2: Domicilio Particular */}
                        <View style={styles.tableRow}>
                            <Cell label="Domicilio Particular" value={t.domicilioParticular} widthLabel={20} widthValue={80} />
                        </View>

                        {/* Fila 3: Domicilio Fiscal */}
                        <View style={styles.tableRow}>
                            <Cell label="Domicilio Fiscal" value={t.domicilioFiscal} widthLabel={20} widthValue={80} />
                        </View>

                        {/* Fila 4: RFC | Teléfono | Correo */}
                        <View style={styles.tableRow}>
                            <Cell label="RFC" value={t.rfc} widthLabel={8} widthValue={17} />
                            <Cell label="Núm. Teléfono" value={t.telefono} widthLabel={15} widthValue={15} />
                            <Cell label="Correo" value={t.correo} widthLabel={10} widthValue={35} />
                        </View>

                        {/* Fila 5: Act. Económica | Entidad Fed. | CURP */}
                        <View style={styles.tableRow}>
                            <Cell label="Act. Económica" value={t.actividadEconomica} widthLabel={15} widthValue={20} />
                            <Cell label="Entidad Fed." value={t.entidadFederativa} widthLabel={15} widthValue={20} />
                            <Cell label="CURP" value={t.curp} widthLabel={10} widthValue={20} />
                        </View>

                        {/* Fila 6: Opinión Cumplí. | Estatus | IdCIF */}
                        <View style={styles.tableRow}>
                            <Cell label="Opinión Cumplí." value={t.opinionCumplimiento} widthLabel={15} widthValue={20} />
                            <Cell label="Estatus" value={t.estatus} widthLabel={10} widthValue={20} />
                            <Cell label="IdCIF" value={t.idCIF} widthLabel={10} widthValue={25} />
                        </View>

                        {/* Fila 7: Régimen Fiscal */}
                        <View style={styles.tableRow}>
                            <Cell label="Régimen Fiscal" value={t.regimenFiscal} widthLabel={20} widthValue={80} />
                        </View>

                        {/* Fila 8: F de nacimiento | Identificación | Clave de Elector */}
                        <View style={styles.tableRow}>
                            <Cell label="F de nacimiento" value={formatDate(t.fechaNacimiento)} widthLabel={15} widthValue={18} />
                            <Cell label="Identificación" value={t.identificacion} widthLabel={15} widthValue={18} />
                            <Cell label="Clave de Elector" value={t.claveElector} widthLabel={15} widthValue={19} />
                        </View>

                        {/* Fila 9: Emisión | Vigencia | NSS */}
                        <View style={styles.tableRow}>
                            <Cell label="Emisión" value={formatDate(t.emisionIdentificacion)} widthLabel={10} widthValue={23} />
                            <Cell label="Vigencia" value={formatDate(t.vigenciaIdentificacion)} widthLabel={10} widthValue={23} />
                            <Cell label="NSS" value={t.nss} widthLabel={10} widthValue={24} />
                        </View>
                    </>
                )}
            </View>

            {/* PM Specific Tables */}
            {type === 'PM' && (
                <>
                    {/* Table Title: Cuadro Accionario actual */}
                    <Text style={[styles.tableTitle, { marginTop: 5 }]}>Cuadro Accionario actual</Text>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '60%', backgroundColor: '#f0f0f0' }]}>
                                <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Accionista</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '20%', backgroundColor: '#f0f0f0' }]}>
                                <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Valor</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '20%', backgroundColor: '#f0f0f0' }]}>
                                <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>%</Text>
                            </View>
                        </View>
                        {data.equity && data.equity.map((item, index) => (
                            <View style={styles.tableRow} key={index}>
                                <View style={[styles.tableCol, { width: '60%' }]}>
                                    <Text style={styles.tableCellValue}>{item.accionista}</Text>
                                </View>
                                <View style={[styles.tableCol, { width: '20%' }]}>
                                    <Text style={styles.tableCellValue}>{item.valor || ''}</Text>
                                </View>
                                <View style={[styles.tableCol, { width: '20%' }]}>
                                    <Text style={styles.tableCellValue}>{item.porcentaje}</Text>
                                </View>
                            </View>
                        ))}
                        {(!data.equity || data.equity.length < 3) && Array.from({ length: 3 - (data.equity ? data.equity.length : 0) }).map((_, index) => (
                            <View style={styles.tableRow} key={`empty-${index}`}>
                                <View style={[styles.tableCol, { width: '60%', height: 15 }]} />
                                <View style={[styles.tableCol, { width: '20%', height: 15 }]} />
                                <View style={[styles.tableCol, { width: '20%', height: 15 }]} />
                            </View>
                        ))}
                    </View>

                    {/* Table Title: Datos del Representante legal */}
                    <Text style={[styles.tableTitle, { marginTop: 5 }]}>Datos del Representante legal</Text>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <Cell label="Nombre" value={lr.nombre} widthLabel={20} widthValue={40} />
                            <Cell label="F de Nacimiento" value={formatDate(lr.fechaNacimiento)} widthLabel={20} widthValue={20} />
                        </View>
                        <View style={styles.tableRow}>
                            <Cell label="Entidad de Nacimiento" value={lr.entidadNacimiento} widthLabel={25} widthValue={25} />
                            <Cell label="Identificación" value={lr.identificacion} widthLabel={15} widthValue={10} />
                            <Cell label="Clave de Elector" value={lr.claveElector} widthLabel={15} widthValue={10} />
                        </View>
                        <View style={styles.tableRow}>
                            <Cell label="Emisión" value={formatDate(lr.emision)} widthLabel={15} widthValue={18} />
                            <Cell label="Vigencia" value={formatDate(lr.vigencia)} widthLabel={15} widthValue={18} />
                            <Cell label="OCR" value={lr.ocr} widthLabel={10} widthValue={24} />
                        </View>
                        <View style={styles.tableRow}>
                            <Cell label="Vencimiento" value={formatDate(lr.vencimiento)} widthLabel={15} widthValue={35} />
                            <Cell label="NSS" value={lr.nss} widthLabel={10} widthValue={40} />
                        </View>
                    </View>

                    {/* Table Title: Datos del Obligado Solidario */}
                    <Text style={[styles.tableTitle, { marginTop: 5 }]}>Datos del Obligado Solidario</Text>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <Cell label="Nombre" value={g.nombre} widthLabel={15} widthValue={35} />
                            <Cell label="F. de Nacimiento" value={formatDate(g.fechaNacimiento)} widthLabel={15} widthValue={15} />
                            <Cell label="CURP" value={g.curp} widthLabel={10} widthValue={10} />
                        </View>
                        <View style={styles.tableRow}>
                            <Cell label="Dirección" value={g.direccion} widthLabel={15} widthValue={85} />
                        </View>
                        <View style={styles.tableRow}>
                            <Cell label="RFC" value={g.rfc} widthLabel={10} widthValue={23} />
                            <Cell label="Identificación" value={g.identificacion} widthLabel={15} widthValue={18} />
                            <Cell label="Clave de Elector" value={g.claveElector} widthLabel={15} widthValue={19} />
                        </View>
                        <View style={styles.tableRow}>
                            <Cell label="Emisión" value={formatDate(g.emision)} widthLabel={15} widthValue={18} />
                            <Cell label="Vigencia" value={formatDate(g.vigencia)} widthLabel={15} widthValue={18} />
                            <Cell label="NSS" value={g.nss} widthLabel={10} widthValue={24} />
                        </View>
                    </View>
                </>
            )}

            {/* PF Specific Tables */}
            {type === 'PF' && (
                <>
                    {/* Table Title: Referencias */}
                    <Text style={styles.tableTitle}>Referencias</Text>
                    <View style={styles.table}>
                        {/* Header Row */}
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '40%', backgroundColor: '#f0f0f0' }]}>
                                <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>NOMBRE</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '30%', backgroundColor: '#f0f0f0' }]}>
                                <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>CONTACTO - NO TELÉFONO</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '30%', backgroundColor: '#f0f0f0' }]}>
                                <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>PARENTESCO</Text>
                            </View>
                        </View>
                        {/* Data Rows */}
                        {data.referencias && data.referencias.map((ref, index) => (
                            <View style={styles.tableRow} key={index}>
                                <View style={[styles.tableCol, { width: '40%' }]}>
                                    <Text style={styles.tableCellValue}>{ref.nombre}</Text>
                                </View>
                                <View style={[styles.tableCol, { width: '30%' }]}>
                                    <Text style={styles.tableCellValue}>{ref.telefono}</Text>
                                </View>
                                <View style={[styles.tableCol, { width: '30%' }]}>
                                    <Text style={styles.tableCellValue}>{ref.parentesco}</Text>
                                </View>
                            </View>
                        ))}
                        {/* Empty rows if less than 3 references */}
                        {(!data.referencias || data.referencias.length < 3) && Array.from({ length: 3 - (data.referencias ? data.referencias.length : 0) }).map((_, index) => (
                            <View style={styles.tableRow} key={`empty-${index}`}>
                                <View style={[styles.tableCol, { width: '40%', height: 15 }]} />
                                <View style={[styles.tableCol, { width: '30%', height: 15 }]} />
                                <View style={[styles.tableCol, { width: '30%', height: 15 }]} />
                            </View>
                        ))}
                    </View>
                </>
            )}

            {/* Common Tables */}
            {/* Table Title: De las características del contrato */}
            <Text style={[styles.tableTitle, type === 'PM' && { marginTop: 5 }]}>De las características del contrato</Text>
            <View style={styles.table}>
                {/* Header Row */}
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '33.33%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>VIGENCIA (meses)</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '33.33%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>FECHA DE INICIO DEL PRIMER PAGO</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '33.33%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>TASA DE INT MORATORIA DIARIA</Text>
                    </View>
                </View>
                {/* Data Row */}
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '33.33%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.contrato.vigenciaMeses}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '33.33%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{formatDate(data.contrato.fechaPrimerPago)}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '33.33%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.contrato.tasaMoratoriaDiaria}%</Text>
                    </View>
                </View>
            </View>

            {/* Table Title: De las características de la renta */}
            <Text style={styles.tableTitle}>De las características de la renta</Text>
            <View style={styles.table}>
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Renta sin IVA</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>IVA</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Total pago mensual c/IVA</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>No. pagos</Text>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>${data.renta.sinIva.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>${data.renta.iva.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>${data.renta.totalConIva.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.renta.numeroPagos}</Text>
                    </View>
                </View>
            </View>

            {/* Table Title: De las características del pago inicial */}
            <Text style={styles.tableTitle}>De las características del pago inicial</Text>
            <View style={styles.table}>
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Enganche</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Comisión por Apertura</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Recuperación de gastos</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Depósito en Garantía</Text>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>${data.pagoInicial.enganche.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>${data.pagoInicial.comisionApertura.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>${data.pagoInicial.recuperacionGastos.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>${data.pagoInicial.depositoGarantia.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '33.33%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Total s/IVA</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '33.33%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>IVA</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '33.33%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Total c/IVA</Text>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '33.33%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>${data.pagoInicial.totalSinIva.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '33.33%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>${data.pagoInicial.iva.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '33.33%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>${data.pagoInicial.totalConIva.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text>
                    </View>
                </View>
            </View>

            {/* Table Title: De las características del auto */}
            <Text style={[styles.tableTitle, { marginTop: type === 'PM' ? 0 : 15 }]}>De las características del auto</Text>
            <View style={styles.table}>
                {/* Row 1 */}
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Marca</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Modelo</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Versión</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Tipo de motor</Text>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.auto.marca}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.auto.modelo}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.auto.version}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.auto.tipoMotor}</Text>
                    </View>
                </View>

                {/* Row 2 */}
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Tipo de auto</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Accesorios adicionales c/IVA</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Estado de la placa</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Agencia / Razón social</Text>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.auto.tipoAuto}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.auto.accesoriosConIva}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.auto.estadoPlaca}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '25%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.auto.agencia}</Text>
                    </View>
                </View>

                {/* Row 3 */}
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '33.33%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>No. Serie</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '33.33%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Motor</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '33.33%', backgroundColor: '#f0f0f0' }]}>
                        <Text style={[styles.tableCellLabel, { textAlign: 'center' }]}>Valor factura</Text>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={[styles.tableCol, { width: '33.33%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.auto.numeroSerie}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '33.33%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>{data.auto.motor}</Text>
                    </View>
                    <View style={[styles.tableCol, { width: '33.33%' }]}>
                        <Text style={[styles.tableCellValue, { textAlign: 'center' }]}>${data.auto.valorFactura.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text>
                    </View>
                </View>
            </View>
        </>
    );
};
